import React from "react";
import Header from "./components/header/header";
import Main from "./components/main/main";
import "./App.scss";

function App() {
  return (
    <>
      <Header />
      <Main />
    </>
  );
}

export default App;
